import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/fontawesome-pro-regular'

function mapStateToProps(state) {
  return {
    index: state.general.get('navigationIndex'),
    headerData: state.general.getIn(['header', 'data']),
    headerAvailable: state.general.getIn(['header', 'available']),
  }
}

function mapDispatchToProps(dispatch) {
  return {}
}

class Header extends PureComponent {
  _headerOption(option, index) {
    const active = this.props.index === index ? 'active' : ''
    const indexText =
      this.props.index > index ? <FontAwesomeIcon icon={faCheck} /> : index + 1

    return (
      <div key={index} className={`header--nav--option ${active}`}>
        <div className='circle'>
          {indexText}
          <svg
            className='circle--svg'
            width='40'
            height='40'
            viewBox='0 0 40 40'
          >
            <circle id='anime' cx='20' cy='20' r='16' />
          </svg>
        </div>
        <span className='text'>{option}</span>
      </div>
    )
  }

  _navigationHeader() {
    return (
      <div className='header--nav'>
        {this.props.headerData.map((option, index) =>
          this._headerOption(option, index)
        )}
      </div>
    )
  }

  render() {
    return (
      <div className='header'>
        <div className='header-wrapper'>
          {this.props.headerAvailable ? this._navigationHeader() : null}
          <div className='header--flex-balancer' />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
